var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center",class:_vm.tagObject},[_c('i',{staticClass:"ri-lg mr-50",class:_vm.tagIcon}),_c('span',{staticClass:"text-bold"},[_vm._v(_vm._s(_vm.getLabel))])])}
var staticRenderFns = []

export { render, staticRenderFns }